import React from "react";
import { Box, Container } from "@mui/material";
import Card from "../Card/Card";
import CustomText from "../../customComponents/customText";
import { translation } from "../../assets/translation";
import "./Footer.module.css";
import {
  handleUrl,
  language,
  blogurl,
  signupurl,
  linkedinUrl,
  instagramUrl,
  facebookUrl,
  whatsUpUrl,
  contactUrl,
  twitterUrl,
  youTubeUrl,
  threadsUrl,
  mastodonUrl,
  bskyUrl,
} from "../../assets/function";
import { Colors } from "../../assets/colors";
import CustomButton from "../../customComponents/customButton";
import CustomImage from "../../customComponents/customImage";
import Instagram from "../../assets/images/instagram.png";
import Facebook from "../../assets/images/facebook.png";
import Linkedin from "../../assets/images/linkedin.png";
import { useNavigate, useLocation } from "react-router-dom";
import WhatsAppIcon from "../../assets/images/whatsapp.svg";
import Twitter from "../../assets/images/twitter.png";
import Youtube from "../../assets/images/youtube.png";
import Mastodon from "../../assets/images/mastodon.png";
import Threads from "../../assets/images/thread.png";
import Bsky from "../../assets/images/blueskyicon.png";
// import callIcon from "../../assets/images/callIcon.png";

let staticText = translation[language];

function Footer() {
  const customImageWidth = 20;
  const customImageHeight = 20;
  const navigate = useNavigate();
  const location = useLocation();
  const showCard = ["/", "/pricing"].includes(location.pathname);
  const showFloatingButton = ["/"].includes(location.pathname);
  const customImageMarginRight = 15;
  const CardBody = (
    <Box sx={styles.cardBodyBox}>
      <CustomText
        desc={staticText.thisisfinal}
        fontFamily="Epilogue"
        colorvalue={Colors.andaihubTxt}
        style={styles.andaihubTxt}
        title3
        fontWeight={400}
      />
      <CustomButton
        style={styles.btnStyle}
        onClick={(event) => {
          handleNavigateOtherClick(event, signupurl);
        }}
        body={
          <Box>
            <CustomText
              desc={staticText.signUpToday}
              fontFamily="Epilogue"
              colorvalue={Colors.white}
              style={styles.btnTextStyle}
              h4
              fontWeight={400}
            />
          </Box>
        }
      />
      <CustomButton
        onClick={(event) => {
          handleNavigateOtherClick(event, contactUrl);
        }}
        style={{
          ...styles.btnStyle,
          backgroundColor: Colors.menuListBgColor,
         
        }}
        body={
          <Box>
            <CustomText
              desc={staticText.contactUs}
              fontFamily="Epilogue"
              colorvalue={Colors.white}
              style={styles.btnTextStyle}
              h4
              fontWeight={400}
            />
          </Box>
        }
      />
    </Box>
  );

  const handleNavigateOtherClick = (event, url) => {
    handleUrl(url, event);
  };

  const handleNavigateOtherClick1 = (event, navigateUrl) => {
    navigate(navigateUrl);
  };

  const Section1 = () => (
    <Box sx={styles.SectionBox1}>
      <CustomText
        desc={staticText.Product}
        fontFamily="Epilogue"
        colorvalue={Colors.menuListBgColor}
        style={styles.btnTextStyle}
        h4
        fontWeight={400}
      />
      <Box
        sx={styles.cursorBox}
        onClick={(event) => {
          handleNavigateOtherClick(event, signupurl);
        }}
      >
        <CustomText
          desc={staticText.signUp}
          fontFamily="Epilogue"
          colorvalue={Colors.footerTxtColorSub}
          style={{ ...styles.btnTextStyle, marginTop: 0.8 }}
          p2
          fontWeight={400}
        />
      </Box>
      <Box
        sx={styles.cursorBox}
        onClick={(event) => {
          handleNavigateOtherClick1(event, "/pricing");
        }}
      >
        <CustomText
          desc={staticText.pricing}
          fontFamily="Epilogue"
          colorvalue={Colors.footerTxtColorSub}
          style={{ ...styles.btnTextStyle, marginTop: 0.5 }}
          p2
          fontWeight={400}
        />
      </Box>
    </Box>
  );
  const Section2 = () => (
    <Box sx={styles.SectionBox2}>
      <CustomText
        desc={staticText.resources}
        fontFamily="Epilogue"
        colorvalue={Colors.menuListBgColor}
        style={styles.btnTextStyle}
        h4
        fontWeight={400}
      />
      <Box
        sx={styles.cursorBox}
        onClick={(event) => {
          handleNavigateOtherClick(event, blogurl);
        }}
      >
        <CustomText
          desc={staticText.blog}
          fontFamily="Epilogue"
          colorvalue={Colors.footerTxtColorSub}
          style={{ ...styles.btnTextStyle, marginTop: 0.8 }}
          p2
          fontWeight={400}
        />
      </Box>
    </Box>
  );
  const Section3 = () => (
    <Box sx={styles.SectionBox3}>
      <CustomText
        desc={staticText.company}
        fontFamily="Epilogue"
        colorvalue={Colors.menuListBgColor}
        style={styles.btnTextStyle}
        h4
        fontWeight={400}
      />
      <Box
        sx={styles.cursorBox}
        onClick={(event) => {
          handleNavigateOtherClick1(event, "/aboutus");
        }}
      >
        <CustomText
          desc={staticText.aboutUs}
          fontFamily="Epilogue"
          colorvalue={Colors.footerTxtColorSub}
          style={{ ...styles.btnTextStyle, marginTop: 0.8 }}
          p2
          fontWeight={400}
        />
      </Box>
      <Box
        sx={styles.cursorBox}
        onClick={(event) => {
          handleNavigateOtherClick1(event, "/info");
        }}
      >
        <CustomText
          desc={staticText.info}
          fontFamily="Epilogue"
          colorvalue={Colors.footerTxtColorSub}
          style={{ ...styles.btnTextStyle, marginTop: 0.5 }}
          p2
          fontWeight={400}
        />
      </Box>
      <Box
        sx={styles.cursorBox}
        onClick={(event) => {
          handleNavigateOtherClick1(event, "/privacy");
        }}
      >
        <CustomText
          desc={staticText.privacyPolicy}
          fontFamily="Epilogue"
          colorvalue={Colors.footerTxtColorSub}
          style={{ ...styles.btnTextStyle, marginTop: 0.5 }}
          p2
          fontWeight={400}
        />
      </Box>
      <Box
        sx={styles.cursorBox}
        onClick={(event) => {
          handleNavigateOtherClick1(event, "/refund");
        }}
      >
        <CustomText
          desc={staticText.refundPolicy}
          fontFamily="Epilogue"
          colorvalue={Colors.footerTxtColorSub}
          style={{ ...styles.btnTextStyle, marginTop: 0.5 }}
          p2
          fontWeight={400}
        />
      </Box>
      <Box
        sx={styles.cursorBox}
        onClick={(event) => {
          handleNavigateOtherClick1(event, "/terms");
        }}
      >
        <CustomText
          desc={staticText.termAndCons}
          fontFamily="Epilogue"
          colorvalue={Colors.footerTxtColorSub}
          style={{ ...styles.btnTextStyle, marginTop: 0.5 }}
          p2
          fontWeight={400}
        />
      </Box>
    </Box>
  );

  const socialSection1 = () => (
    <>
      <Box
        sx={styles.cursorBox}
        onClick={(event) => {
          handleNavigateOtherClick(event, linkedinUrl);
        }}
      >
        <CustomImage
          filename={Linkedin}
          width={customImageWidth}
          height={customImageHeight}
          marginRight={customImageMarginRight}
          sx={styles.image}
        />
      </Box>
      <Box
        sx={styles.cursorBox}
        onClick={(event) => {
          handleNavigateOtherClick(event, instagramUrl);
        }}
      >
        <CustomImage
          filename={Instagram}
          width={customImageWidth}
          height={customImageHeight}
          sx={styles.image}
          marginRight={customImageMarginRight}
        />
      </Box>
      <Box
        sx={styles.cursorBox}
        onClick={(event) => {
          handleNavigateOtherClick(event, facebookUrl);
        }}
      >
        <CustomImage
          filename={Facebook}
          width={customImageWidth}
          height={customImageHeight}
          sx={styles.image}
          marginRight={customImageMarginRight}
        />
      </Box>
      <Box
        sx={styles.cursorBox}
        onClick={(event) => {
          handleNavigateOtherClick(event, twitterUrl);
        }}
      >
        <CustomImage
          filename={Twitter}
          width={customImageWidth}
          height={customImageHeight}
          sx={styles.image}
          marginRight={customImageMarginRight}
        />
      </Box>
    </>
  );
  const socialSection2 = () => (
    <>
      <Box
        sx={styles.cursorBox}
        onClick={(event) => {
          handleNavigateOtherClick(event, youTubeUrl);
        }}
      >
        <CustomImage
          filename={Youtube}
          width={customImageWidth}
          height={customImageHeight}
          sx={styles.image}
          marginRight={customImageMarginRight}
        />
      </Box>
      <Box
        sx={styles.cursorBox}
        onClick={(event) => {
          handleNavigateOtherClick(event, threadsUrl);
        }}
      >
        <CustomImage
          filename={Threads}
          width={customImageWidth}
          height={customImageHeight}
          sx={styles.image}
          marginRight={customImageMarginRight}
        />
      </Box>
      <Box
        sx={styles.cursorBox}
        onClick={(event) => {
          handleNavigateOtherClick(event, mastodonUrl);
        }}
      >
        <CustomImage
          filename={Mastodon}
          width={customImageWidth}
          height={customImageHeight}
          sx={styles.image}
          marginRight={customImageMarginRight}
        />
      </Box>

      <Box
        sx={styles.cursorBox}
        onClick={(event) => {
          handleNavigateOtherClick(event, bskyUrl);
        }}
      >
        <CustomImage
          filename={Bsky}
          width={customImageWidth}
          height={customImageHeight}
          sx={styles.image}
          marginRight={customImageMarginRight}
        />
      </Box>
    </>
  );

  return (
    <Box sx={styles.footerWrapper}>
      {showCard && <Box sx={styles.backgroundSplit} />}
      <Container maxWidth="xl" sx={styles.containerStyle}>
        {showCard && (
          <Card
            paddingTop={{
              xs: 3,    // smaller padding on mobile
              sm: 3,    // slightly larger on tablets
              md: 4,    // medium devices
              lg: 5     // large devices
            }}
            paddingBottom={{
              xs: 4,    // smaller padding on mobile
              sm: 4,    // slightly larger on tablets
              md: 5,    // medium devices
              lg: 6     // large devices
            }}
            paddingLeft={{
              xs: 3,    // smaller padding on mobile
              sm: 3,    // slightly larger on tablets
              md: 4,    // medium devices
              lg: 5     // large devices
            }}
            paddingRight={{
              xs: 3,    // smaller padding on mobile
              sm: 3,    // slightly larger on tablets
              md: 4,    // medium devices
              lg: 5     // large devices
            }}
            width={{
              xs: "100%",  // For extra-small devices (phones)
              sm: "90%",  // For small devices (tablets)
              md: "85%",  // For medium devices (small laptops)
              lg: "80%",  // For large devices (laptops)
              xl: "70%"   // For extra-large devices (large desktops)
            }}
            justifyContent={"center"}
            style={{ position: "relative", zIndex: 1 }}
          >
            {CardBody}
          </Card>
        )}
        <Box sx={styles.aboutUsDetailsBox}>
          <Box sx={styles.section1}>
            {Section1()}
            {Section2()}
            {Section3()}
          </Box>
          <Box sx={{paddingLeft: {xs: 2, sm: 3, md: 0, lg: 0}}}>
            <Box sx={styles.section2}>{socialSection1()}</Box>
            <Box sx={{ ...styles.section2, marginTop: 2.3 }}>
              {socialSection2()}

            </Box>
          </Box>
        </Box>
        <Box sx={styles.copyRightBox}>
          <CustomText
            desc={staticText.copyRight}
            fontFamily="Epilogue"
            colorvalue={Colors.footerTxtColor}
            style={styles.btnTextStyle}
            p2
            fontWeight={400}
          />
          <CustomText
            desc={staticText.appl}
            fontFamily="Epilogue"
            colorvalue={Colors.footerTxtColor}
            style={{ ...styles.btnTextStyle, marginTop: 0.8 }}
            p2
            fontWeight={400}
          />
        </Box>
      </Container>

      {/* Add floating buttons */}
      {showFloatingButton && (
        <Box sx={styles.floatingButtons}>
          <CustomButton
            style={styles.whatsappButton}
            onClick={(event) => handleNavigateOtherClick(event, whatsUpUrl)}
            body={
              <Box sx={styles.buttonContent}>
                <CustomImage
                  filename={WhatsAppIcon}
                  width={25}
                  height={"auto"}
                />

                <CustomText
                  desc={staticText.chatWithUs}
                  fontFamily="Epilogue"
                  colorvalue={Colors.white}
                  style={{
                    ...styles.floatingButtonText,
                    marginTop: 0.6,
                  }}
                  h4
                  fontWeight={400}
                />
              </Box>
            }
          />
          <CustomButton
            style={styles.callButton}
            onClick={() => {}}
            body={
              <Box sx={styles.buttonContent1}>
                <i
                  className="fa-solid fa-phone-volume"
                  style={styles.buttonIcon}
                ></i>
              </Box>
            }
          />
        </Box>
      )}
    </Box>
  );
}

export default Footer;

const styles = {
  cursorBox: {
    cursor: "pointer",
  },
  andaihubTxt:{
    fontSize:{xs:23,md:36}
  },
  // Add these new styles
  footerWrapper: {
    position: "relative",
    width: "100%",
    overflow: "hidden",
    backgroundColor: Colors.white,
  },
  backgroundSplit: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "20%", // Takes up half the height
    backgroundColor: Colors.themeColor, // Or whatever shade of red you're using
    zIndex: 1,
  },
  section1: {
    display: "flex",
    marginTop: {
      xs: 4,  // 32px for mobile
      sm: 6,  // 48px for tablets
      md: 8,  // 64px for laptops
      lg: 8   // 64px for larger screens
    },
    flexDirection: {
      xs: "column",
      sm: "column",
      md: "column",
      lg: "row",
      xl: "row"
    },
    gap: {
      xs: 3,
      sm: 4
    }
  },
  section2: {
    display: "flex",
    marginTop: {
      xs: 0,  // 32px for mobile
      sm: 6,  // 48px for tablets
      md: 7,  // 56px for laptops
      lg: 8   // 64px for larger screens
    },
    justifyContent: {
      xs: "flex-start",
      sm: "flex-start",
    },
    gap: {
      xs: 0,
      sm: 0
    }
  },
  copyRightBox: {
    width: "100%",
    display: "flex", 
    flexDirection: {
      xs: "column",
      sm: "column"
    },
    justifyContent: "center",
    alignItems: {
      xs: "flex-start",
      md: "center"
    },
    marginTop: {
      xs: 4,  // 48px for mobile
      sm: 8,  // 64px for tablets
      md: 10, // 80px for laptops
      lg: 10  // 80px for larger screens
    },
    paddingLeft: {
      xs: 2,
      sm: 0,
      md: 0,
      lg: 0
    },
    gap: {
      xs: 0,
      sm: 2,
      md:0
    }

  },
  aboutUsDetailsBox: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    flexDirection: {
      xs: "column",
      md: "row"
    },
    alignItems: {
      xs: "flex-start",
      md: "flex-start",
    },
    gap: {
      xs: 4,
      md: 6
    },

  },
  btnStyle: {
    marginTop: 3,
    borderRadius: 56,
    paddingLeft: {
      xs: 5,  // smaller padding on mobile
      sm: 20,  // slightly larger on tablets
      md: 25,  // medium devices
      lg: 30   // large devices
    },
    paddingRight: {
      xs: 5,  // smaller padding on mobile
      sm: 20,  // slightly larger on tablets
      md: 25,  // medium devices
      lg: 30   // large devices
    },
    paddingTop: {
      xs: 1,    // smaller padding on mobile
      sm: 1.2,  // slightly larger on tablets
      md: 1.3,  // medium devices
      lg: 1.5   // large devices
    },
    paddingBottom: {
      xs: 1,    // smaller padding on mobile
      sm: 1.2,  // slightly larger on tablets
      md: 1.3,  // medium devices
      lg: 1.5   // large devices
    },
    width: {
      xs: '90%',  // For mobile devices
      sm: '100%',  // For tablets
      md: '80%',  // For small laptops
      lg: '70%',   // For larger screens
      xl: '70%'
    },
    justifyContent: "center",
    alignItems: "center",
    justifyItems: "center",
    backgroundColor: Colors.red,
    display: "flex",
  },
  cardBodyBox: {
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    justifyItems: "center"
  },
  btnTextStyle: {
    textTransform: "none",
    fontSize: {
      xs: '14px',  // For mobile devices
      sm: '15px',  // For tablets
      md: '16px',  // For small laptops/desktops
      lg: '16px',  // For larger screens
      xl: '15px'   // For extra large screens
    }
  },
  appBarStyle: {},
  containerStyle: {
    width: "100%",
    paddingBottom: {
      xs: 13,  // 24px for mobile
      sm: 4,  // 32px for tablets
      md: 5,  // 40px for laptops
      lg: 5   // 40px for larger screens
    },
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
  },
  image: {
    width: "100%", // Make sure images scale based on the Box size
    height: "auto", // Ensure aspect ratio is maintained
  },
  boxImage: {
    width: `${100 / 5}%`,
    justifyContent: "center",
    alignItems: "center",
    justifyItems: "center",
    paddingLeft: 5,
    paddingRight: 5,
  },
  SectionBox1: {
    marginRight: 10,
    paddingLeft: {
      xs: 2,  // 16px for mobile
      sm: 3,  // 24px for tablets
      md: 4,  // 32px for laptops
      lg: 5   // 40px for larger screens
    },
    paddingRight: {
      xs: 2,
      sm: 3,
      md: 4,
      lg: 5
    }
  },
  SectionBox2: {
    marginRight: 10,
    paddingLeft: {
      xs: 2,
      sm: 3,
      md: 4,
      lg: 5
    },
    paddingRight: {
      xs: 2,
      sm: 3,
      md: 4,
      lg: 5
    }
  },
  SectionBox3: {
    marginRight: 10,
    paddingLeft: {
      xs: 2,
      sm: 3,
      md: 4,
      lg: 5
    },
    paddingRight: {
      xs: 2,
      sm: 3,
      md: 4,
      lg: 5
    }
  },
  floatingButtons: {
    position: "fixed",
    bottom: 20,
    paddingLeft: 2,
    paddingRight: 2,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
    alignItems: "flex-end",
    zIndex: 1000,
  },
  whatsappButton: {
    backgroundColor: Colors.chatWithUsColor,
    color: "white",
    border: "none",
    borderRadius: "50px",
    padding: "1px 5px",
    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "16px",
  },
  callButton: {
    borderRadius: "50%",
    padding: "10px",
    minWidth: "50px",
    height: "70px",
    // Fix 1: Change linear-gradient syntax
    background: "linear-gradient(135deg, #1e90ff, #00bfff)",
    // Fix 2: Ensure perfect circle with equal width/height
    width: "70px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 5px 15px rgba(0, 0, 0, 0.3)",
    transition: "box-shadow 0.3s ease, transform 0.3s ease",
    zIndex: 1000,
  },
  buttonContent: {
    padding: "6px 11px",
    display: "flex",
    alignItems: "center",
    gap: "10px",
    cursor: "pointer",
  },
  buttonContent1: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    cursor: "pointer",
  },
  buttonIcon: {
    color: Colors.white,
    fontSize: 30,
  },
  floatingButtonText: {
    textTransform: "none",
  },
};
